function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuardians(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.7774 4.10915L7.8266 1.92881C8.55914 1.53437 9.44085 1.53437 10.1734 1.92881L14.1778 4.085C15.5043 4.79928 16.2555 6.24869 16.0096 7.67691C15.352 11.4968 13.9144 15.611 8.99972 16.8367C6.4346 16.2008 4.85512 14.8817 3.82425 13.2708C2.77293 11.6279 2.26555 9.63888 1.94894 7.64176C1.72519 6.2304 2.47058 4.81283 3.7774 4.10915Z",
    stroke: "#C7C5D1",
    style: {
      stroke: "#C7C5D1",
      stroke: "color(display-p3 0.7804 0.7725 0.8196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41248 6.13495L7.81588 8.37019C7.62086 8.64321 7.81603 9.02245 8.15154 9.02245H10.1656C10.518 9.02245 10.7082 9.43582 10.4788 9.7034L8.58748 11.9099",
    stroke: "#C7C5D1",
    style: {
      stroke: "#C7C5D1",
      stroke: "color(display-p3 0.7804 0.7725 0.8196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.65,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardians);
export default __webpack_public_path__ + "static/media/Guardians.0bbe3b10a4dcd7cb015e5b5ab831714b.svg";
export { ForwardRef as ReactComponent };